import { cn } from "@synthesis/shared-utils";
import type { ReactNode } from "react";

type MonitoringCardProps = {
  title: string;
  extra?: ReactNode;
  children: ReactNode;
  className?: string;
};

export const MonitoringCard = ({ title, extra, children, className }: MonitoringCardProps) => (
  <section className={cn("bg-neutrals-white flex flex-col gap-6 rounded-xl p-6", className)}>
    <div className="flex items-center gap-6">
      <h3 className="subtitle-lg text-type-common">{title}</h3>
      {extra}
    </div>
    {children}
  </section>
);
